module.exports = __webpack_public_path__ + "img/ic_part_task_order.202d3a25.svg";